import $ from 'sbf-design-system/js/jquery';
import throttle from 'lodash/throttle';
import banner from 'sbf-design-system-component/banners/banner';
import 'sbf-design-system-component/header/header';
import Overlay from 'sbf-design-system-component/overlays/overlay';
import 'sbf-design-system-component/forms/base';
import 'sbf-design-system-component/broadcast_messages/broadcast_message';
import 'sbf-design-system-component/back_to_top/index.js';
import 'sbf-design-system/js/lib/parsley';
import {
  braintreeClient,
  braintreePaypalCheckout
} from './lib/braintree';
import _initDeviceData from '../lib/braintree-device-data';
import BraintreeHostedFields from '../lib/braintree-hosted-fields';
import './lib/footer.js';
import 'rails-ujs';

const initDeviceData = (clientInstance) => _initDeviceData(clientInstance, '#donation_payment_details_attributes_device_data');

const braintreeAvailable =
  window.gon.braintree_token &&
  window.braintree &&
  window.braintree.client &&
  window.braintree.paypalCheckout &&
  window.paypal;

const clientPaymentScriptsSucceeded =
  window.braintree &&
  window.braintree.client &&
  window.braintree.paypalCheckout &&
  window.paypal;

let donationFrequency = '';

// amounts set in controller
const onceSuggestedAmounts = window.gon.suggested_giving_amounts.once;
const monthlySuggestedAmounts = window.gon.suggested_giving_amounts.monthly;

function braintreeError () {
  if (window.gon.braintree_token && !clientPaymentScriptsSucceeded) {
    $('.processor-error .braintree-down').append('<div>You may have an issue with a VPN or firewall causing this. Please contact St. Baldrick\'s support at (888) 899-2253.</div>');
  }
  $('.processor-error, .processor-error .braintree-down').css('display', 'block');
  $('#donate_monthly').prop('disabled', true);
}

if (!braintreeAvailable) {
  $(braintreeError);
}

const $form = $('#donation-form');
const $inputFields = $('#donor-attribute-inputs-container');
const $donationAmountInput = $('#donation_amount');
let $finalAmount;
$form.attr('novalidate', 'novalidate');

/* Transaction Fee */
const processingFeePercentage = window.gon.transaction_fee;

$('#fee').text(calculateProcessingFee($donationAmountInput.val()));

// set device size
const visibleMobileElement = $('#visible_mobile');
const visibleTabletElement = $('#visible_tablet');
let deviceSize = 'unknown';

let mobileHeaderHeight = false;
let tabletHeaderHeight = false;

const $donateMainHeader = $('#donate-main-header');
const pageHeader = $('#header, #fbHeader');

const setDeviceSize = () => {
  const isVisibleMobile = visibleMobileElement.is(':visible');
  const isVisibleTablet = visibleTabletElement.is(':visible');

  if (isVisibleMobile) {
    deviceSize = 'mobile';
    if (mobileHeaderHeight === false) {
      mobileHeaderHeight = +pageHeader.outerHeight();

      if ($donateMainHeader.is(':visible')) {
        mobileHeaderHeight += +$donateMainHeader.outerHeight();
      }
    }
  } else if (isVisibleTablet) {
    deviceSize = 'tablet';
    if (tabletHeaderHeight === false) {
      tabletHeaderHeight = +pageHeader.outerHeight();

      if ($donateMainHeader.is(':visible')) {
        tabletHeaderHeight += +$donateMainHeader.outerHeight();
      }
    }
  } else {
    deviceSize = 'desktop';
  }
};
$(window).resize(setDeviceSize);

setDeviceSize();

const isWindowMobile = () => {
  return deviceSize === 'mobile';
};

const isWindowDesktop = () => {
  return deviceSize === 'desktop';
};

let switchMode = 'none';
const zipFields = $('[for="donation_donor_attributes_address_attributes_zip"], #donation_donor_attributes_address_attributes_zip');

const adjustRequiredFieldsByDeviceType = () => {
  if (isWindowMobile() && switchMode !== 'mobile') {
    switchMode = 'mobile';
    $('.donation-zip-input').prop('required', true);
    $('#donation_donor_attributes_phone').prop('required', false);
    zipFields.appendTo('.mobile-donation-zip').change();
  } else if (!isWindowMobile() && switchMode === 'mobile') {
    switchMode = 'desktop';
    $('.donation-zip-input').prop('required', !window.sbf.logged_in);
    $('#donation_donor_attributes_phone').prop('required', true);
    zipFields.appendTo('.desktop-donation-zip').change();
  }
};
$(window).resize(adjustRequiredFieldsByDeviceType);
adjustRequiredFieldsByDeviceType();

$('#changeAmount').on('click', () => {
  $donationAmountInput.focus();
  $('html,body').animate({ scrollTop: $('#section-donation-suggested-giving-amount').offset().top }, 1000);
  return false;
});

const setAmountInButton = () => {
  const amount = $donationAmountInput.val().replace(/,/g, '');
  const parsed = parseFloat(amount);
  let formattedAmount = '0';
  if (isNaN(parsed) || parsed === 0) {
    formattedAmount = '';
    $('#donation-review-breakdown-total-amount, #donation-review-breakdown-amount').text(`$${formattedAmount}`);
    $('#amountDisplay').text('0.00');
  } else {
    formattedAmount = parsed.toFixed(2).replace(/./g, (c, i, a) => {
      return i && c !== '.' && (a.length - i) % 3 === 0 ? `,${c}` : c;
    });
    $('#donation-review-breakdown-total-amount, #donation-review-breakdown-amount').text(`$${formattedAmount}`);
    $('#amountDisplay').text(formattedAmount);
  }
  setTransactionFee();
  updateDonationAmountWithFee();
};

// Set the transaction fee based on the amount in the checkbox
const setTransactionFee = () => {
  const value = getAmount();
  const processingFee = calculateProcessingFee(value);
  $('#fee, #donation-review-breakdown-fee-amount').text(`$${processingFee}`);
  if ($('#donation_fee_covered').is(':checked')) {
    $('#donation_fee_amount').val(`$${processingFee}`);
    $('#donation-review-fee-amount-container').css('display', 'flex');
  } else {
    $('#donation_fee_amount').val(0);
    $('#donation-review-fee-amount-container').css('display', 'none');
  }
};

$('#donation_fee_covered').on('change', function () {
  if ($(this).is(':checked')) {
    const value = getAmount();
    const processingFeeCheckedAmount = calculateProcessingFee(value);
    $('#donation_fee_amount').val(processingFeeCheckedAmount);
    $('#donation-review-fee-amount-container').css('display', 'flex');
  } else {
    $('#donation_fee_amount').val(0);
    $('#donation-review-fee-amount-container').css('display', 'none');
  }
});

// Toggling between Individual/Business/Organization
const $businessName = $('.business-name');
const $businessNameInput = $('#donation_donor_attributes_organization_name');
const $isBusinessAddress = $('#donation_donor_attributes_address_attributes_is_business');
const $addressBusinessName = $('.address-business-name');
const $nameHolder = $('#name_holder');
const $firstName = $('#donation_donor_attributes_first_name');
const $lastName = $('#donation_donor_attributes_last_name');
const $donorTypeInput = $('input[name=\'donation[donor_attributes][type]\']');

$donorTypeInput.change((e) => {
  const donorType = $(e.target).val();
  setupDonorTypeInput(donorType);
});

const setupDonorTypeInput = (donorType) => {
  if (window.sbf && window.sbf.logged_in) {
    return;
  }

  if (donorType === 'individual') {
    $businessName.hide();
    // Set the required fields based on donor type
    $businessNameInput.prop('required', false);
    $firstName.prop('required', true);
    $lastName.prop('required', true);
    $('#review--donation_donor_attributes_type_individual').prop('checked', true);
    $('.donor-entity-type-attribute-input').text(`${donorType}`);
  } else if (donorType === 'business') {
    $businessName.show();
    $nameHolder.text('Business Name');
    $isBusinessAddress.prop('checked', true);
    $addressBusinessName.show();
    // Set the required fields based on donor type
    $firstName.prop('required', false);
    $lastName.prop('required', false);
    $businessNameInput.prop('required', true);
    $('#review--donation_donor_attributes_type_business').prop('checked', true);
    $('.donor-entity-type-attribute-input').text(`${donorType}`);
  } else if (donorType === 'foundation') {
    $businessName.show();
    $nameHolder.text('Foundation/Organization Name');
    $isBusinessAddress.prop('checked', true);
    $addressBusinessName.show();
    // Set the required fields based on donor type
    $firstName.prop('required', false);
    $lastName.prop('required', false);
    $businessNameInput.prop('required', true);
    $('#review--donation_donor_attributes_type_foundation').prop('checked', true);
    $('.donor-entity-type-attribute-input').text(`${donorType}`);
  }
};

const setupBusinessAddress = () => {
  if ($isBusinessAddress.is(':checked')) {
    $addressBusinessName.show();
  } else {
    $addressBusinessName.hide();
  }
};
$isBusinessAddress.change(setupBusinessAddress);

// Toggle the Tribute fields
const $hasTribute = $('#donation_tribute_attributes_is_tribute');
const $tributeInput = $('#tributeFields');
const $tributeFirst = $('#donation_tribute_attributes_first_name');
const $tributeLast = $('#donation_tribute_attributes_last_name');

const setupHasTribute = () => {
  if ($hasTribute.is(':checked')) {
    $tributeInput.show(500);
    $tributeFirst.prop('required', true);
    $tributeLast.prop('required', true);
    $('.required-info-fields--tribute').addClass('is-selected');
  } else {
    $tributeInput.hide(500);
    $tributeFirst.prop('required', false);
    $tributeLast.prop('required', false);
    $('.required-info-fields--tribute').removeClass('is-selected');
  }
};
$hasTribute.change(setupHasTribute);

// Fill In Sidebar as Form Values get entered
const $donorInfo = $('#donation-review-details-donor-info-container');
const $donorName = $('#donation-review-donor-name');
const $donorAddress = $('#donation-review-donor-address');
const $donorEmail = $('#donation-review-donor-email');
const $donorPhone = $('#donation-review-donor-phone');
const $donorReviewType = $('#donation-review-donor-type');
const $nameSelection = $('.name-selection');
const $country = $('#donation_donor_attributes_address_attributes_country');
const dataISOCompliantCountries = JSON.parse($country.attr('data-iso-compliant-countries'));
let $paymentMethod = '';

const hasDonorInfo = () => {
  const donorType = $('input[name=\'donation[donor_attributes][type]\']:checked').val();

  if (donorType === 'individual' && $firstName.val() !== '') {
    return true;
  }

  if (donorType !== 'individual' && $businessNameInput.val() !== '') {
    return true;
  }

  return false;
};

const showHideDonorInfo = () => {
  if ($('#donate-main').attr('data-payment') === 'cc' && !hasDonorInfo()) {
    $donorInfo.hide(500);
  } else {
    $donorInfo.show(500);
    const donorType = $('input[name=\'donation[donor_attributes][type]\']:checked').val();

    if (donorType === 'foundation') {
      $donorReviewType.text('organization');
    } else {
      $donorReviewType.text(donorType);
    }
  }
};
$('#donation_donor_attributes_first_name, #donation_donor_attributes_organization_name, input[name="donation[donor_attributes][type]"]').change(showHideDonorInfo);

let $customRecognitionName = '';

const setNameSelectUsername = () => {
  const donorType = $('input[name=\'donation[donor_attributes][type]\']:checked').val();
  const nameArray =
    donorType !== 'individual' &&
    $businessNameInput.val() !== ''
      ? [$businessNameInput.val()]
      : [
        $('#donation_donor_attributes_prefix').val(),
        $firstName.val(),
        $('#donation_donor_attributes_middle_initial').val(),
        $lastName.val(),
        $('#donation_donor_attributes_suffix').val()
      ];

  if (nameArray.join(' ').trim() !== '') {
    $donorName.css('display', 'block');
    $donorName.text(nameArray.join(' '));
    $nameSelection.show(200);
    $customRecognitionName = nameArray.join(' ').trim();
    $('#nameSelectUsername').text($customRecognitionName);
  }

  showHideDonorInfo();
};

$(`
  #donation_donor_attributes_prefix,
  #donation_donor_attributes_first_name,
  #donation_donor_attributes_middle_initial,
  #donation_donor_attributes_last_name,
  #donation_donor_attributes_suffix,
  #donation_donor_attributes_organization_name,
  input[name="donation[donor_attributes][type]"]
`).change(setNameSelectUsername);

const setupDonorAddress = () => {
  const country = $('#donation_donor_attributes_address_attributes_country').val();
  const state = $('#donation_donor_attributes_address_attributes_state').val() || $('#donation_donor_attributes_address_attributes_region').val();
  const address1 = $('#donation_donor_attributes_address_attributes_address1').val();
  const address2 = $('#donation_donor_attributes_address_attributes_address2').val();
  const city = $('#donation_donor_attributes_address_attributes_city').val();
  const zip = $('#donation_donor_attributes_address_attributes_zip').val();

  const hasAddress = [address1, address2, city, state, zip].filter((val) => val).join(', ').length > 0;

  if (hasAddress) {
    const addressArray = [address1, address2, city, state, country, zip]
      .filter((val) => val)
      .join(', ');
    $donorAddress.css('display', 'block');
    $donorAddress.text(addressArray);
  }
};
$(`
  #donation_donor_attributes_address_attributes_address1,
  #donation_donor_attributes_address_attributes_address2,
  #donation_donor_attributes_address_attributes_city,
  #donation_donor_attributes_address_attributes_state,
  #state,
  #donation_donor_attributes_address_attributes_country,
  #donation_donor_attributes_address_attributes_region,
  #donation_donor_attributes_address_attributes_zip
`).change(setupDonorAddress);

const setDonorEmail = () => {
  const email = $('#donation_donor_attributes_email').val();
  $donorEmail.css('display', 'block');
  $donorEmail.text(email);
};
$('#donation_donor_attributes_email').change(setDonorEmail);

const setDonorPhone = () => {
  const phone = $('#donation_donor_attributes_phone').val();
  $donorPhone.css('display', 'block');
  $donorPhone.text(phone);
};
$('#donation_donor_attributes_phone').change(setDonorPhone);

// Unhide Custom Name input if 'custom' is checked
const showHideCustomName = (value) => {
  if (value === 'custom') {
    $('.custom-name').show(500);
    $('#donation_custom_name').prop('required', true);
    $('.required-info-fields--custom-name').addClass('is-selected');
  } else {
    $('.custom-name').hide(500);
    $('#donation_custom_name').prop('required', false);
    $('.required-info-fields--custom-name').removeClass('is-selected');
  }
};
$('input[name=\'donation[name_select]\']').change((e) =>
  showHideCustomName($(e.target).val())
);

$country.prop('required', true);

// Enable/disable fields based on selected country.
const showHideCountryProvinceRegion = (countryVal) => {
  if (dataISOCompliantCountries.includes(countryVal)) {
    $('#donation_donor_attributes_address_attributes_state').prop('disabled', false);
    $('#donation_donor_attributes_address_attributes_region').prop('disabled', true);
  } else {
    $('#donation_donor_attributes_address_attributes_state').prop('disabled', true);
    $('#donation_donor_attributes_address_attributes_region').prop('disabled', false);
  }
  if (countryVal === 'US') {
    if (!window.sbf.logged_in) {
      $('#donation_donor_attributes_address_attributes_zip').prop('required', true);
    }

    $('[for="donation_donor_attributes_address_attributes_zip"]').text('Zip');
  } else if (countryVal === 'CA') {
    if (!window.sbf.logged_in) {
      $('#donation_donor_attributes_address_attributes_zip').prop('required', true);
    }

    $('[for="donation_donor_attributes_address_attributes_zip"]').text('Postal Code');
  } else {
    $('[for="donation_donor_attributes_address_attributes_zip"]').text('Postal Code');
    $('#donation_donor_attributes_address_attributes_zip').prop('required', false);
  }
};
$country.change((e) => {
  const countryVal = $(e.target).val();
  showHideCountryProvinceRegion(countryVal);
});

const $submitDonationButton = $('#donation-submit-button');
const $creditCardNumber = $('#number');

$creditCardNumber.on('focusout change keyup', (e) => {
  if (e.which && e.which !== 13) { return; } // only trigger on [enter] keyup

  if (e.type === 'focusout') {
    $('#donate-main, .section-donation-review-submit').attr('data-payment', 'cc');
  }
  $creditCardNumber.val($creditCardNumber.val().replace(/\s+/g, ''));
});

$submitDonationButton.click((e) => {
  e.preventDefault();
  if ($submitDonationButton.prop('disabled')) {
    return false;
  }

  const invalidFieldSelector = BraintreeHostedFields.getFirstInvalidField();

  $submitDonationButton.prop('disabled', true);
  if (!validateDonationForm()) {
    $('.invalid:first').focus();
    if (invalidFieldSelector) {
      BraintreeHostedFields.instance.focus(invalidFieldSelector);
    }
    if (!window.navigator.userAgent.match(/iPad|iPhone/i)) {
      const invalidInput = $('.invalid:first');
      if (invalidInput.length) {
        $('html, body').animate(
          { scrollTop: invalidInput.offset().top - 150 },
          300,
          function () {}
        );
      }
    }

    $submitDonationButton.prop('disabled', false);
    return false;
  }

  if ($('.g-recaptcha').length) {
    // recaptcha callback below will submit the form
    window.grecaptcha.execute();
    return;
  }

  $paymentMethod = $('#donate-main').attr('data-payment');
  if ($paymentMethod === 'cc') {
    submit();
  } else {
    $form.submit();
  }
});

const initBrainTreeHostedFields = () => {
  window.braintree.client.create({
    authorization: window.gon.braintree_token
  }, function (err, clientInstance) {
    if (err) {
      console.error(err);
      return;
    }

    initDeviceData(clientInstance);
    BraintreeHostedFields.create(clientInstance);
  });
};

let $applePayInstance;
const initApplePay = () => {
  if (!braintreeAvailable) {
    return;
  }

  if (!window.ApplePaySession) {
    $('#apple-pay-button').hide();
  }

  if (
    window.ApplePaySession &&
    window.ApplePaySession.supportsVersion(3) &&
    window.ApplePaySession.canMakePayments()
  ) {
    console.log('apple pay available');

    window.braintree.client.create(
      {
        authorization: window.gon.braintree_token
      },
      function (clientErr, clientInstance) {
        if (clientErr) {
          console.error('Error creating client:', clientErr);
          return;
        }

        initDeviceData(clientInstance);
        window.braintree.applePay.create(
          {
            client: clientInstance
          },
          function (applePayErr, applePayInstance) {
            if (applePayErr) {
              console.error('Error creating applePayInstance:', applePayErr);
              return;
            }

            if (window.ApplePaySession) {
              $applePayInstance = applePayInstance;
            }
          }
        );
      }
    );
  } else {
    console.log('apple pay unavailable');
  }
};

const $applePayButton = $('#apple-pay-button');

// When you click the apple pay button
$applePayButton.click((e) => {
  const paymentRequest = $applePayInstance.createPaymentRequest({
    total: {
      label: 'St. Baldrick\'s',
      amount: $finalAmount
    },

    // We recommend collecting billing address information, at minimum
    // billing postal code, and passing that billing postal code with
    // all Apple Pay transactions as a best practice.
    requiredBillingContactFields: ['postalAddress'],
    requiredShippingContactFields: ['email', 'phone']
  });

  const session = new window.ApplePaySession(3, paymentRequest);
  session.onvalidatemerchant = function (event) {
    $applePayInstance.performValidation(
      {
        validationURL: event.validationURL,
        displayName: 'St. Baldrick\'s'
      },
      function (err, merchantSession) {
        if (err) {
          // You should show an error to the user, e.g. 'Apple Pay failed to load.'
          banner.showError('Apple Pay failed to load.', false, 4000);
          return;
        }
        session.completeMerchantValidation(merchantSession);
      }
    );
  };

  session.onpaymentauthorized = function (event) {
    $applePayInstance.tokenize(
      {
        token: event.payment.token
      },
      function (tokenizeErr, payload) {
        if (tokenizeErr) {
          console.error('Error tokenizing Apple Pay:', tokenizeErr);
          session.completePayment(window.ApplePaySession.STATUS_FAILURE);
          tokenizingFailure(tokenizeErr);
          return;
        }

        // Send payload.nonce to your server
        $('#donation_payment_details_attributes_nonce').val(`${payload.nonce}`);
        $('#donation_payment_details_attributes_gateway').val('braintree');

        if (!window.sbf.logged_in) {
          const payinfo = event.payment.billingContact;
          const shipinfo = event.payment.shippingContact;

          // concat with empty string to cast to string
          $firstName.val(`${payinfo.givenName}`).change();
          $lastName.val(`${payinfo.familyName}`).change();
          $('#donation_donor_attributes_address_attributes_address1')
            .val(`${payinfo.addressLines[0]}`)
            .change();
          if (payinfo.addressLines[1]) {
            $('#donation_donor_attributes_address_attributes_address2')
              .val(`${payinfo.addressLines[1]}`)
              .change();
          }
          $('#donation_donor_attributes_address_attributes_city')
            .val(`${payinfo.locality}`)
            .change();
          $('#donation_donor_attributes_address_attributes_zip')
            .val(`${payinfo.postalCode}`)
            .change();
          $('#donation_donor_attributes_phone')
            .val(`${shipinfo.phoneNumber}`)
            .change();
          $('#donation_donor_attributes_email')
            .val(`${shipinfo.emailAddress}`)
            .change();
          $country
            .val(payinfo.countryCode.toUpperCase())
            .change();

          if (dataISOCompliantCountries.includes(payinfo.countryCode.toUpperCase())) {
            $('#donation_donor_attributes_address_attributes_state')
              .val(`${payinfo.administrativeArea}`)
              .change();
          } else {
            $('#donation_donor_attributes_address_attributes_region')
              .val(`${payinfo.administrativeArea}`)
              .change();
          }
        }

        // After you have transacted with the payload.nonce,
        // call `completePayment` to dismiss the Apple Pay sheet.
        session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
        $('#donation_payment_method').val('applepay');

        // goto review step here
        showReviewDonationStep();
      }
    );
  };

  session.oncancel = function () {
    $('#donate-main, .section-donation-review-submit').attr('data-payment', 'cc');
  };

  // validate form here
  // we need to get contact information before accepting donation
  let apRequiredsValid = true;
  // remove all invalids and test again
  //    invalids are set on cc fields when clicking go on mobile
  $form
    .find('[required]')
    .closest('.inline-input')
    .removeClass('invalid');
  $form
    .find('[required]')
    .not('.cc-fields')
    .each((_i, el) => {
      if (!validateField(el)) {
        $(el)
          .closest('.inline-input')
          .addClass('invalid');
        apRequiredsValid = false;
        $('.invalid:first input').focus();

        if (!window.navigator.userAgent.match(/iPad|iPhone/i)) {
          const invalidInput = $('.invalid:first :input');
          if (invalidInput.length) {
            $('html, body')
              .stop()
              .animate(
                { scrollTop: invalidInput.offset().top - 150 },
                300,
                function () {}
              );
          }
        }
      }

      if (!apRequiredsValid) {
        banner.showError('Please provide the required information.', false, 4000);
      }
    });

  if (apRequiredsValid) {
    session.begin();
  }
});

// Make sure to have https://pay.google.com/gp/p/js/pay.js loaded on your page
// You will need a button element on your page styled according to Google's brand guidelines
// https://developers.google.com/pay/api/web/guides/brand-guidelines

const $googlePayButton = $('#google-pay-button');
const paymentsClient = new window.google.payments.api.PaymentsClient({
  environment: window.gon.google_pay_env
});

const initGooglePay = () => {
  if (!braintreeAvailable) {
    return;
  }

  window.braintree.client.create(
    {
      authorization: window.gon.braintree_token
    },
    function (clientErr, clientInstance) {
      if (clientErr) {
        console.error('Error creating client:', clientErr);
        return;
      }

      initDeviceData(clientInstance);
      window.braintree.googlePayment.create(
        {
          client: clientInstance,
          googlePayVersion: 2,
          googleMerchantId: window.gon.google_pay_merchant_id // Optional in sandbox; if set in sandbox, this value must be a valid production Google Merchant ID
        },
        function (googlePaymentErr, googlePaymentInstance) {
          paymentsClient
            .isReadyToPay({
              // see https://developers.google.com/pay/api/web/reference/object#IsReadyToPayRequest
              apiVersion: 2,
              apiVersionMinor: 0,
              allowedPaymentMethods: googlePaymentInstance.createPaymentDataRequest()
                .allowedPaymentMethods
            })
            .then(function (response) {
              if (response.result) {
                // setup google pay button
                const button = paymentsClient.createButton({
                  buttonColor: 'black',
                  buttonType: 'plain',
                  buttonSizeMode: 'fill',
                  onClick: () => {}
                });
                $googlePayButton.append(button);

                button.addEventListener('click', function (event) {
                  event.preventDefault();
                  const paymentDataRequest = googlePaymentInstance.createPaymentDataRequest(
                    {
                      emailRequired: true,
                      transactionInfo: {
                        currencyCode: 'USD',
                        totalPriceStatus: 'FINAL',
                        totalPrice: $('#donation_amount_with_fee').val()
                      }
                    }
                  );

                  // We recommend collecting billing address information, at minimum
                  // billing postal code, and passing that billing postal code with all
                  // Google Pay card transactions as a best practice.
                  // See all available options at https://developers.google.com/pay/api/web/reference/object
                  const cardPaymentMethod = paymentDataRequest.allowedPaymentMethods[0];
                  cardPaymentMethod.parameters.billingAddressRequired = true;
                  cardPaymentMethod.parameters.billingAddressParameters = {
                    format: 'FULL',
                    phoneNumberRequired: true
                  };

                  paymentsClient
                    .loadPaymentData(paymentDataRequest)
                    .then(function (paymentData) {
                      googlePaymentInstance.parseResponse(paymentData, function (err, result) {
                        if (err) {
                          // Handle parsing error
                          console.error(err);
                        }
                        // Send result.nonce to your server
                        // result.type may be either "AndroidPayCard" or "PayPalAccount", and
                        // paymentData will contain the billingAddress for card payments

                        // Send payload.nonce to your server
                        $('#donation_payment_details_attributes_nonce').val(`${result.nonce}`);
                        $('#donation_payment_details_attributes_gateway').val('braintree');

                        // After you have transacted with the payload.nonce,
                        $('#donation_payment_method').val('googlepay');

                        if (!window.sbf.logged_in) {
                          const payinfo = paymentData.paymentMethodData.info.billingAddress;

                          // concat with empty string to cast to string
                          const firstName = payinfo.name.split(' ').slice(0, -1).join(' ');
                          const lastName = payinfo.name.split(' ').slice(-1).join(' ');
                          $firstName.val(`${firstName}`).change();
                          $lastName.val(`${lastName}`).change();

                          if (payinfo.address1) {
                            $('#donation_donor_attributes_address_attributes_address1')
                              .val(`${payinfo.address1}`)
                              .change();
                          }
                          if (payinfo.address2) {
                            $('#donation_donor_attributes_address_attributes_address2')
                              .val(`${payinfo.address2}`)
                              .change();
                          }
                          if (payinfo.locality) {
                            $('#donation_donor_attributes_address_attributes_city')
                              .val(`${payinfo.locality}`)
                              .change();
                          }
                          if (payinfo.postalCode) {
                            $('#donation_donor_attributes_address_attributes_zip')
                              .val(`${payinfo.postalCode}`)
                              .change();
                          }
                          if (payinfo.phoneNumber) {
                            $('#donation_donor_attributes_phone')
                              .val(`${payinfo.phoneNumber}`)
                              .change();
                          }
                          if (paymentData.email) {
                            $('#donation_donor_attributes_email')
                              .val(`${paymentData.email}`)
                              .change();
                          }

                          $country
                            .val(payinfo.countryCode.toUpperCase())
                            .change();

                          if (dataISOCompliantCountries.includes(payinfo.countryCode.toUpperCase())) {
                            $('#donation_donor_attributes_address_attributes_state')
                              .val(`${payinfo.administrativeArea}`)
                              .change();
                          } else {
                            $('#donation_donor_attributes_address_attributes_region')
                              .val(`${payinfo.administrativeArea}`)
                              .change();
                          }
                        }

                        // goto review step here
                        showReviewDonationStep();
                      });
                    })
                    .catch(function (err) {
                      if (err.statusCode === 'CANCELED') {
                        $('#donate-main, .section-donation-review-submit').attr('data-payment', 'cc');
                      }
                      // Handle errors
                    });
                });
              }
            })
            .catch(function (err) {
              console.error('catch', err);
              // Handle errors
            });
        }
      );
    }
  );
};

window.captchaCallback = function (token) {
  $('.g-recaptcha').addClass('g-recaptcha-submitted');
  $paymentMethod = $('#donate-main').attr('data-payment');
  if ($paymentMethod === 'cc') {
    submit();
  } else {
    $form.submit();
  }
};

window.errorCaptchaCallback = function () {
  banner.showError(
    'This donation cannot be processed. Please reload the page and try submitting your donation again.',
    true
  );
  return false;
};

const submit = throttle(async () => {
  try {
    BraintreeHostedFields.instance.tokenize(function (tokenizeErr, payload) {
      if (tokenizeErr) {
        console.error(JSON.stringify(tokenizeErr.message));
      } else {
        $('#donation_payment_details_attributes_nonce').val(`${payload.nonce}`);
        $('#donation_payment_details_attributes_gateway').val('braintree');
        clearCardDetails();
        $form.submit();
      }
    });
  } catch (e) {
    tokenizingFailure(e);
    return false;
  }
}, 5000);

const clearCardDetails = () => {
  $form.find('input, select').filter(function (i, el) {
    return ($(el).attr('data-braintree-name'));
  }).val('').change();
};

const tokenizingFailure = (err) => {
  console.log('Tokenizing Failure!');
  $.post('/donate/log/create', { message: JSON.stringify(err) }, function (
    data
  ) {
    banner.showError(`This payment cannot be processed. Please try again or call your credit card issuing company for more information. UUID: ${data}`, true);
  });
  $submitDonationButton.prop('disabled', false);
  if ($('.g-recaptcha').length) {
    window.grecaptcha.reset();
  }
};

const bannerizeGenericError = () => {
  const $formErrorContainer = $('#formErrorContainer');

  if ($formErrorContainer.length > 0) {
    if (isWindowMobile()) {
      $('html, body').animate({ scrollTop: $formErrorContainer.offset().top - 130 }, 'slow');
      return false;
    }

    if (isWindowDesktop()) {
      const errorMessage = $formErrorContainer.html();
      banner.showError(errorMessage, true);
    }
  }
};

const bannerizeInvalidSessionError = () => {
  const $invalidSessionErrorContainer = $('#invalidSessionErrorContainer');

  if ($invalidSessionErrorContainer.length > 0) {
    if (isWindowMobile()) {
      $('html, body').animate({ scrollTop: $invalidSessionErrorContainer.offset().top - 130 }, 'slow');
      return false;
    }

    const errorMessage = $invalidSessionErrorContainer.html();
    banner.showError(errorMessage, true);
  }
};

let flow = 'checkout';
const initPaypalButton = async () => {
  if (!braintreeAvailable) {
    return;
  }
  try {
    const client = await braintreeClient(window.gon.braintree_token);
    await braintreePaypalCheckout({
      client,
      enableBillingAddress: true,
      flow: function () {
        return flow;
      },
      buttonSelector: '#paypal-button',
      amountCB: () =>
        $('#donation_amount_with_fee')
          .val()
          .replace(/,/g, ''),
      cb: ({ nonce, details }) => {
        $('#donation_payment_details_attributes_nonce').val(`${nonce}`);
        $('#donation_payment_details_attributes_gateway').val('braintree');
        $('#donation_payment_method').val('paypal');

        if (!window.sbf.logged_in) {
          // concat with empty string to cast to string
          $firstName.val(`${details.firstName}`).change();
          $lastName.val(`${details.lastName}`).change();
          const billingAddress = details.billingAddress;

          if (billingAddress.line1) {
            $('#donation_donor_attributes_address_attributes_address1')
              .val(`${details.billingAddress.line1}`)
              .change();
          }
          if (billingAddress.line2) {
            $('#donation_donor_attributes_address_attributes_address2')
              .val(`${details.billingAddress.line2}`)
              .change();
          }
          if (billingAddress.city) {
            $('#donation_donor_attributes_address_attributes_city')
              .val(`${details.billingAddress.city}`)
              .change();
          }
          if (billingAddress.postalCode) {
            $('#donation_donor_attributes_address_attributes_zip')
              .val(`${details.billingAddress.postalCode}`)
              .change();
          }

          if (details.hasOwnProperty('phone')) { // eslint-disable-line no-prototype-builtins
            $('#donation_donor_attributes_phone')
              .val(`${details.phone}`)
              .change();
          }
          $('#donation_donor_attributes_email')
            .val(`${details.email}`)
            .change();
          $country
            .val(details.countryCode.toUpperCase())
            .change();

          if (dataISOCompliantCountries.includes(details.billingAddress.countryCode.toUpperCase())) {
            $('#donation_donor_attributes_address_attributes_state')
              .val(`${details.billingAddress.state}`)
              .change();
          } else {
            $('#donation_donor_attributes_address_attributes_region')
              .val(`${details.billingAddress.state}`)
              .change();
          }
        }

        // go to review step
        showReviewDonationStep();
      }
    });
  } catch (e) {
    tokenizingFailure(e);
    return false;
  }
};

const initVenmoButton = async () => {
  try {
    // Available based on rollout flag.
    if (!$('#venmo-button').length) {
      return;
    }
    // Ref: https://developer.paypal.com/braintree/docs/guides/venmo/client-side
    window.braintree.client.create({
      // authorization: window.gon.braintree_token
      authorization: window.gon.braintree_token
    }, (clientErr, clientInstance) => {
      // Stop if there was a problem creating the client. This could happen if there is a network error or if the authorization is invalid.
      if (clientErr) {
        console.error('VENMO - Error creating client:', clientErr);
        return;
      }

      initDeviceData(clientInstance);
      window.braintree.venmo.create({
        client: clientInstance,
        allowDesktop: true,
        // paymentMethodUsage property available in v3.77.0+
        // multi_use: Request authorization for future payments (vaulting allowed).
        // single_use: Request authorization for a one-time payment (vaulting not allowed).
        paymentMethodUsage: 'multi_use',
        // Add allowNewBrowserTab if your checkout page does not support relaunching in a new tab when returning from the Venmo app. This can be omitted otherwise.
        allowNewBrowserTab: false
      }, (venmoErr, venmoInstance) => {
        if (venmoErr) {
          console.error('VENMO - Error creating Venmo:', venmoErr);
          return;
        }

        // Verify browser support before proceeding.
        if (!venmoInstance.isBrowserSupported()) {
          const $donationPaymentButtons = $('.donation-payment-method__button');
          $('#venmo-button').hide();
          // Add for edge case scenario on tablet with only paypal and venmo active.
          if ($donationPaymentButtons.length === 2) {
            $donationPaymentButtons[0].style.width = '100%';
          }

          console.log('VENMO - Browser does not support Venmo');
          return;
        }

        displayVenmoOption(venmoInstance);
      });
    });

    const displayVenmoOption = (venmoInstance) => {
      $('#venmo-button').on('click', function (event) {
        event.preventDefault();
        const $this = $(this);
        $this.prop('disabled', true);

        venmoInstance.tokenize((tokenizeErr, payload) => {
          $this.prop('disabled', false);

          if (tokenizeErr) {
            handleVenmoError(tokenizeErr);
          } else {
            handleVenmoSuccess(payload);
          }
        });
      });
    };

    const handleVenmoError = (err) => {
      if (err.code === 'VENMO_DESKTOP_CANCELED') {
        $('#donate-main, .section-donation-review-submit').attr('data-payment', 'cc');
      }
      console.error('VENMO - An error occurred:', err.message);
    };

    const handleVenmoSuccess = (payload) => {
      $('#donation_payment_method').val('venmo');
      $('#donation_payment_details_attributes_nonce').val(payload.nonce);
      $('#donation_payment_details_attributes_gateway').val('braintree');

      if (!window.sbf.logged_in) {
        $firstName.val(`${payload.details.payerInfo.firstName}`).change();
        $lastName.val(`${payload.details.payerInfo.lastName}`).change();

        if (payload.details.payerInfo.hasOwnProperty('phoneNumber')) { // eslint-disable-line no-prototype-builtins
          $('#donation_donor_attributes_phone').val(`${payload.details.payerInfo.phoneNumber}`).change();
        }
        $('#donation_donor_attributes_email').val(`${payload.details.payerInfo.email}`).change();
      }

      // Go to review step.
      showReviewDonationStep();
    };
  } catch (e) {
    tokenizingFailure(e);
    return false;
  }
};

$(() => {
  initBrainTreeHostedFields();
  bannerizeGenericError();
  bannerizeInvalidSessionError();
  setAmountInButton();
  const donorType = $('input[name=\'donation[donor_attributes][type]\']:checked').val();
  setupDonorTypeInput(donorType);
  const nameSelect = $('input[name=\'donation[name_select]\']:checked').val();
  showHideCustomName(nameSelect);
  setupBusinessAddress();
  setupHasTribute();
  showHideDonorInfo();
  setNameSelectUsername();
  setupDonorAddress();
  setDonorEmail();
  setDonorPhone();
  showHideCountryProvinceRegion($country.val());
  adjustRequiredFieldsByDeviceType();
  window.localStorage.removeItem('promoCode');
  setAmountState();
  setDonationTypeState();
  setPromoCodeState();
  initPaypalButton();
  initApplePay();
  initGooglePay();
  initVenmoButton();
});

function validateDonationForm () {
  let requiredsValid = true;
  let phoneInvalid = false;
  let emailInvalid = false;
  let fieldsInvalid = 0;
  // check for name inputs longer than 255 characters
  const $partialCharacterLimit = 100;
  const $fullCharacterLimit = 255;
  const $first = $firstName.val().length;
  const $last = $lastName.val().length;
  const $customName = $('#donation_custom_name').val().length;
  const $customRadioButton = document.getElementById('donation_name_select_custom');
  const $orgName = $('#donation_donor_attributes_address_attributes_organization_name').val().length;

  // If email field is visible then it is required. This prevents users
  // from removing the required property prior to submitting the form.
  $('#donation_donor_attributes_email:visible').attr('required', 'required');

  // determine what inputs to check
  let $inputsToCheck = '';
  $paymentMethod = $('#donate-main').attr('data-payment');
  if ($paymentMethod === 'cc') {
    requiredsValid = BraintreeHostedFields.validate();
    $inputsToCheck = $form.find('[required]').not('.cc-fields');
  } else {
    $inputsToCheck = $form.find('[required]').not('.cc-fields');
  }

  $inputsToCheck.each((_i, el) => {
    if (!validateField(el)) {
      $(el).closest('.inline-input').addClass('invalid');
      fieldsInvalid = $('.invalid').length;

      // special handling for state/province/region
      if (el.name === 'state') {
        $('#states_wrapper').addClass('invalid');
      }

      if (el.name === 'donation[donor_attributes][phone]') {
        phoneInvalid = true;
      }

      if (el.name === 'donation[donor_attributes][email]') {
        emailInvalid = true;
      }

      $form.addClass('form__error');
      requiredsValid = false;
    }
  });

  // first and last name can't be longer than 100(separately).
  if ($first > $partialCharacterLimit) {
    banner.showError('First name cannot be longer than 100 characters.', false, 4000);
    return false;
  }

  if ($last > $partialCharacterLimit) {
    banner.showError('Last name cannot be longer than 100 characters.', false, 4000);
    return false;
  }

  if ($customRadioButton.checked && $customName > $fullCharacterLimit) {
    banner.showError('Custom name cannot be longer than 255 characters.', false, 4000);
    return false;
  }

  if ($customRecognitionName.length > $fullCharacterLimit) {
    banner.showError('Name cannot be longer than 255 characters.', false, 4000);
    return false;
  }

  if ($orgName > $fullCharacterLimit) {
    banner.showError('Business name cannot be longer than 255 characters.', false, 4000);
    return false;
  }

  if (phoneInvalid && fieldsInvalid === 1) {
    banner.showError('Please enter a valid phone number.', false, 4000);
    return false;
  } else if (emailInvalid && fieldsInvalid === 1) {
    banner.showError('Please enter a valid email address.', false, 4000);
    return false;
  } else if (!requiredsValid) {
    banner.showError('Please provide the required information.', false, 4000);
    return false;
  } else {
    return true;
  }
}

$donationAmountInput.on('change', validateNumber);

const validNumber = /^\d*\.?\d*$/;
function validateNumber () {
  const amount = $donationAmountInput.val().replace(/[,\s]/g, '');
  $donationAmountInput.val(amount);

  if (validNumber.test(amount)) {
    setAmountInButton();
    setTransactionFee();
    return true;
  } else {
    banner.showError('Please enter a valid amount.', true, 4000);
    $donationAmountInput.closest('.inline-input').addClass('invalid');
    return false;
  }
}

function validateDonorEmail (email) {
  const emailPattern = /^(?:[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+([.][a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]*)+|["](?:[^\\x01-\\x08\\x11\\x12\\x14-\\x1f\\x7f\\x0d\\x22\\x5c]|(\\x5c[\\x01-\\x09\\x11\\x12\\x14-\\x7f]))+["]|(?:[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+|["](?:[^\\x01-\\x08\\x11\\x12\\x14-\\x1f\\x7f\\x0d\\x22\\x5c]|(\\x5c[\\x01-\\x09\\x11\\x12\\x14-\\x7f]))+["])([.](?:[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+|["](?:[^\\x01-\\x08\\x11\\x12\\x14-\\x1f\\x7f\\x0d\\x22\\x5c]|(\\x5c[\\x01-\\x09\\x11\\x12\\x14-\\x7f]))+["]))*)@(?:([A-Za-z0-9-]{1,63}[.])+[A-Za-z]{2,})$/;
  if (!emailPattern.test(email)) {
    return false;
  }
  return true;
}

$form.find('input').on('keyup', formFieldChangedHandler);
$form.find('select').on('change', formFieldChangedHandler);

function formFieldChangedHandler (e) {
  const el = e.target;
  const $el = $(el);

  if (($el.closest('.inline-input').hasClass('invalid') || $el.hasClass('invalid')) && validateField(el)) {
    $el.closest('.inline-input').removeClass('invalid');
    $form.removeClass('form__error');

    // special handling for state/province/region
    if (el.name === 'state') {
      $('#states_wrapper').addClass('invalid');
    }
  }
}

function validateField (el) {
  let valid = true;

  // special field checks first
  if (el.name === 'donation[donor_attributes][phone]') {
    if (!validatePhoneNumber(el.value)) {
      valid = false;
    }
  }

  if (el.name === 'donation[donor_attributes][email]') {
    if (!validateDonorEmail(el.value)) {
      valid = false;
    }
  }

  if (!valid || !$(el).parsley().isValid(true)) {
    return false;
  }
  return true;
}

function validatePhoneNumber (mightBeAPhoneNumber) {
  // strip anything that's not a digit and make sure there are 10 or more of what's left
  const onlyNumbers = mightBeAPhoneNumber.replace(/[^0-9]/g, '');
  // not requiring area code currently
  return onlyNumbers.length >= 7;
}

function calculateProcessingFee (amount) {
  return ((processingFeePercentage * amount) / 100).toFixed(2).replace(/./g, (c, i, a) => {
    return i && c !== '.' && (a.length - i) % 3 === 0 ? `,${c}` : c;
  });
}

// International Overlay
const internationalOverlayEl = $('#internationalOverlay');
const internationalOverlayShown =
  document.cookie.indexOf('internationaloverlayshown=1') !== -1;
if (!internationalOverlayShown && internationalOverlayEl.length) {
  const internationalOverlay = new Overlay(internationalOverlayEl, {
    full_screen: true
  });

  const internationalOverlayHide = internationalOverlay.hide.bind(
    internationalOverlay
  );
  internationalOverlay.hide = function () {
    document.cookie = 'internationaloverlayshown=1; path=/';
    internationalOverlayHide();
  };
  $('.international-overlay__btns__us').click(internationalOverlay.hide);
  internationalOverlay.show();
}

// Privacy Policy
const privacyPolicyOverlayEl = $('#privacyPolicyOverlay');
const privacyPolicyOverlay = new Overlay(privacyPolicyOverlayEl, {
  full_screen: true
});

$('#privacy-policy-link').on('click', () => {
  privacyPolicyOverlay.show();
});

const donorInputsInit = () => {
  // disable or enable donor inputs based on whether logged in
  $.each($('#donor-attribute-inputs-container :input:not(#donation_donor_attributes_address_attributes_zip)'),
    function () {
      $(this).prop('disabled', window.sbf.logged_in);
    }
  );
};
donorInputsInit();

$('body').on('click', '#other-amount-close', () => {
  hideOtherAmount();
});

let previousSelectedAmount;

$('input[name=amounts]').change(() => {
  if ($('#donation-suggested-giving-amounts-other').is(':checked')) {
    showOtherAmount();
  } else {
    previousSelectedAmount = $('input[name=amounts]:checked').val();
    $donationAmountInput.val(previousSelectedAmount);
    setTransactionFee();
    setAmountInButton();
    updateDonationAmountWithFee();
  }
  setAmount();
});

$('input[name="donation[donation_type]"]').change(() => {
  setAmountInButton();
});

$('.donation-suggested-giving-type-switch__input, #donation_amount, input[name=amounts] ').change(function () {
  updateURLParams();
  setTransactionFee();
});

$('input[name="donation[donation_type]"]').change(function () {
  const urlDonationTypeParam = new URLSearchParams(window.location.search).get('donation_type');

  if (urlDonationTypeParam === 'donate_once') {
    setDonationTypeAmounts(onceSuggestedAmounts);
    setAmountState();
  } else {
    setDonationTypeAmounts(monthlySuggestedAmounts);
    setAmountState();
  }
  setTransactionFee();
});

const setDonationTypeAmounts = (suggestedAmounts) => {
  const $donationAmountOption = $('input[name=amounts]');
  const $donationAmountOptionLabel = $('label[value]');

  suggestedAmounts.forEach((amount, index) => {
    $donationAmountOption[index].setAttribute('id', `amounts_${amount}`);
    $donationAmountOption[index].setAttribute('value', `${amount}`);
    $donationAmountOptionLabel[index].setAttribute('value', `${amount}`);
    $donationAmountOptionLabel[index].setAttribute('for', `amounts_${amount}`);
    $donationAmountOptionLabel[index].textContent = `$${amount}`;
  });
};

const updateURLParams = () => {
  // get url pathname (this will allow it to work on alt ports) so we can build the url
  // pathname example /donate

  // get current url with query strings
  const url = new URL(window.location);
  // pull out just the query strings
  const params = new URLSearchParams(url.search.slice(1));

  const promoCodeParam = window.localStorage.getItem('promoCode');
  if (promoCodeParam !== null) {
    params.set('promo', promoCodeParam);
  }

  // get value from amount field, and append it to query string/url
  const amount = +$donationAmountInput.val().replace(/,/g, '');
  if (amount > 0) {
    params.set('amount', amount);
  }

  // check if donation type switch is once or monthly
  if ($('#donate_once').is(':checked')) {
    // update flow based on [one-time or monthly switch]
    flow = 'checkout';
    params.set('donation_type', 'donate_once');
    donationFrequency = 'Once';
    $('#donation-review-breakdown-type').text(`Giving ${donationFrequency}`);
  } else {
    // update flow based on [one-time or monthly switch]
    flow = 'vault';
    params.set('donation_type', 'donate_monthly');
    donationFrequency = 'Monthly';
    $('#donation-review-breakdown-type').text(`Giving ${donationFrequency}`);
  }

  const pathname = `${window.location.pathname}?`;
  window.history.replaceState(
    {
      id: 'Donate'
    },
    '',
    pathname + params
  );
};

const showOtherAmount = () => {
  $('#donation-suggested-giving-amounts-container').hide();
  $('#donation-suggested-giving-other-container').show();
  $donationAmountInput.trigger('keyup');
};

const setDonationAmountUrl = () => {
  const temp = parseFloat(getUrlVars().amount) || 0;
  const donationTypeParam = new URLSearchParams(window.location.search).get('donation_type');

  if (temp === 0 && donationTypeParam === 'donate_once') {
    $donationAmountInput.val(parseInt(onceSuggestedAmounts[1]));
  } else if (temp === 0 && donationTypeParam === 'donate_monthly') {
    $donationAmountInput.val(parseInt(monthlySuggestedAmounts[1]));
  } else {
    $donationAmountInput.val(temp.toFixed(2));
  }
};

const hideOtherAmount = () => {
  $('#donation-suggested-giving-other-container').hide();
  $('#donation-suggested-giving-amounts-container').show();
  const currentUrlParams = new URLSearchParams(window.location.search);

  if (currentUrlParams.get('donation_type') === 'donate_once') {
    if (onceSuggestedAmounts.includes(parseInt($donationAmountInput.val()))) {
      const $previousSelectedInput = $(`input[name=amounts][value="${$donationAmountInput.val()}"]`);
      $previousSelectedInput.prop('checked', true).trigger('change');
    } else {
      $donationAmountInput.val(parseInt(onceSuggestedAmounts[1]));
      currentUrlParams.set('amount', parseInt(onceSuggestedAmounts[1]));
      $('.opt2').trigger('click').trigger('change');
    }
  } else {
    if (monthlySuggestedAmounts.includes(parseInt($donationAmountInput.val()))) {
      const $previousSelectedInput = $(`input[name=amounts][value="${$donationAmountInput.val()}"]`);
      $previousSelectedInput.prop('checked', true).trigger('change');
    } else {
      $donationAmountInput.val(parseInt(monthlySuggestedAmounts[1]));
      currentUrlParams.set('amount', parseInt(monthlySuggestedAmounts[1]));
      $('.opt2').trigger('click').trigger('change');
    }
  }
  updateURLParams();
  setAmountInButton();
};

const setAmount = () => {
  // set the selected amount value on the #donation_amount input
  let value = parseInt(onceSuggestedAmounts[1]);
  value = getAmount();
  $donationAmountInput.val(value);
};

const getAmount = () => {
  let currentAmount;
  if ($donationAmountInput.val() === undefined || $donationAmountInput.val().length === 0) {
    currentAmount = '';
  } else {
    currentAmount = $donationAmountInput.val();
  }

  if (currentAmount) {
    return currentAmount;
  } else {
    return $('input[name=amounts]:checked').val();
  }
};

const updateDonationAmountWithFee = () => {
  // get the current amount on button
  const currentDonationAmount = parseFloat(getAmount());
  const currentAmountFormatted = currentDonationAmount.toFixed(2);
  const processingFee = ((processingFeePercentage * currentDonationAmount) / 100).toFixed(2);
  let newAmount;

  if ($('#donation_fee_covered').is(':checked')) {
    newAmount = (parseFloat(currentAmountFormatted) + parseFloat(processingFee)).toFixed(2).replace(/./g, (c, i, a) => {
      return i && c !== '.' && (a.length - i) % 3 === 0 ? `,${c}` : c;
    });
  } else {
    newAmount = currentAmountFormatted.replace(/./g, (c, i, a) => {
      return i && c !== '.' && (a.length - i) % 3 === 0 ? `,${c}` : c;
    });
  }

  const parsed = parseFloat(newAmount);
  if (isNaN(parsed) || parsed <= 0) {
    $('#donation-review-breakdown-total-amount, #donation-amount-total-amount').text('$0.00');
  } else {
    $('#donation-review-breakdown-total-amount, #donation-amount-total-amount').text(`$${newAmount}`);
  }

  const strippedAmount = newAmount.replace(/,/g, '');
  $('#donation_amount_with_fee').val(strippedAmount);
  $finalAmount = strippedAmount;
};
$('#donation_fee_covered').change(updateDonationAmountWithFee);

const getUrlVars = () => {
  const vars = [];
  let hash;
  const hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (let i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
};

function checkCookie () {
  document.cookie = 'testcookie=1';
  const cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
  // Delete cookie
  document.cookie = 'testcookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC';
  return cookieEnabled ? true : showCookieFail();
}

function showCookieFail () {
  banner.showError('Cookies must be enabled for this site. Please enable the cookies in your browser and reload the page.', false);
  $submitDonationButton
    .prop('disabled', true)
    .addClass('disabled');
  $('#donate-to__form__input')
    .prop('disabled', true)
    .addClass('disabled');
  $('#searchButton')
    .prop('disabled', true)
    .addClass('disabled');
  $('#donateGeneralFund')
    .prop('disabled', true)
    .addClass('disabled');
}

function checkProcessors () {
  if (window.gon.braintree_token === null) {
    $('.processor-error').css('display', 'block');
    $('.braintree-down').css('display', 'block');
  }
}

const setAmountState = () => {
  // Set amount from query string if set
  if (getUrlVars().amount !== undefined && getUrlVars().amount !== 0) {
    setDonationAmountUrl();
    showOtherAmount();
  }

  const amount = parseFloat(getAmount());

  if (isNaN(amount) || amount <= 0) {
    // no valid amount set, so show default suggested giving amount
    $donationAmountInput.val(parseInt(onceSuggestedAmounts[1]));
    hideOtherAmount();
  } else {
    // check if suggested amount
    if ($(`#amounts_${amount}`).length) {
      $(`#amounts_${amount}`).click();
      hideOtherAmount();
    } else {
      showOtherAmount();
    }
  }
};

const setDonationTypeState = () => {
  if (
    getUrlVars().donation_type !== undefined &&
    getUrlVars().donation_type === 'donate_monthly'
  ) {
    $('#donate_monthly')
      .prop('checked', true)
      .trigger('change');
  }
};

const setPromoCodeState = () => {
  if (getUrlVars().promo === undefined) {
    return false;
  }
  window.localStorage.setItem('promoCode', getUrlVars().promo);
};

window.onload = function () {
  checkCookie();
  checkProcessors();
};

$('.donation-payment-method__button').on('click', function () {
  $paymentMethod = $(this).data('payment');

  if ($paymentMethod !== 'cc') {
    $firstName.prop('required', false).change();
    $lastName.prop('required', false).change();
    $('#donation_donor_attributes_phone').prop('required', false).change();
    $('#donation_donor_attributes_email').prop('required', false).change();
    $('#donation_donor_attributes_address_attributes_zip').prop('required', false).change();
    $businessNameInput.prop('required', false).change();
  }

  $('#donate-main').addClass('payment-method-selected');
  $('#donate-main, .section-donation-review-submit').attr('data-payment', $paymentMethod);

  // move stuff from page load to after selecting payment method
  setNameSelectUsername();
});

function showReviewDonationStep () {
  setDonorEmail();
  setDonorPhone();
  setupDonorAddress();
  setNameSelectUsername();
  showHideDonorInfo();

  // setup change this overlay
  const changeThisOverlay = new Overlay($('#changeThisOverlay'), {
    full_screen: true,
    heading: 'Edit your information'
  });

  // override the default hide to validate form before closing
  const changeThisOverlayHideFunc = changeThisOverlay.hide;
  changeThisOverlay.hide = function () {
    if (!changeThisSaveValidation()) {
      return;
    }
    changeThisOverlayHideFunc.call(this);
  };

  $('#changeThisTrigger, .review--donor-type').on('click', (e) => {
    const donorType = $('.review--donor-type:checked').val();
    if (donorType === 'individual') {
      $('#donation_donor_attributes_type_individual').prop('checked', true);
    } else if (donorType === 'business') {
      $('#donation_donor_attributes_type_business').prop('checked', true);
    } else if (donorType === 'foundation') {
      $('#donation_donor_attributes_type_foundation').prop('checked', true);
    }

    // attach each input to the $form
    $('#donor-attribute-inputs-container input, #donor-attribute-inputs-container select').each(function () {
      $(this).attr('form', 'donation-form');
    });

    $('#changeThisOverlayContent').append($inputFields);
    $inputFields.css('display', 'block');
    setNameSelectUsername();
    setupDonorTypeInput(donorType);
    changeThisOverlay.show();
  });

  function changeThisSaveValidation () {
    // validate change this overlay
    let changeThisValid = true;
    const $changeDonorInfoOverlay = $('#changeThisOverlay');

    // If email field is visible then it is required. This prevents users
    // from removing the required property prior to submitting the form.
    $('#donation_donor_attributes_email:visible').attr('required', 'required');

    $changeDonorInfoOverlay.find('[required]').closest('.inline-input').removeClass('invalid');
    $changeDonorInfoOverlay.find('[required]').not('.cc-fields').each((_i, el) => {
      if (!validateField(el)) {
        $(el).closest('.inline-input').addClass('invalid');
        changeThisValid = false;
        $('.invalid:first input').focus();

        if (!window.navigator.userAgent.match(/iPad|iPhone/i)) {
          const invalidInput = $('.invalid:first :input');
          if (invalidInput.length) {
            $('html, body').stop().animate({ scrollTop: invalidInput.offset().top - 150 }, 300, function () {});
          }
        }
      }
    });

    if (!changeThisValid) {
      banner.showError('Please provide the required information.', false, 4000);
      return false;
    }

    if (changeThisValid) {
      return true;
    }
  }

  $('#changeThisSave').on('click', (e) => {
    if (changeThisSaveValidation()) {
      $form.append($inputFields);
      $inputFields.css('display', 'none');
      changeThisOverlay.hide();
    }
  });

  // prevent overlay from submitting with invalid input fields
  $('#changeThisOverlay').on('keydown', function (e) {
    if (e.keyCode === 13) {
      return false;
    }
  });

  $('#donate-main').addClass('fullpage-review');
}

// Ecard
const ecardData = JSON.parse(sessionStorage.getItem('ecard_data'));

if (ecardData) {
  $('#ecard_recipient_email').val(ecardData.recipient);
  $('#ecard_send_date').val(ecardData.ecard_send_date);
  $('#ecard_confirmation').val(ecardData.ecard_confirmation_email);
  $('#ecard_design_by').val(ecardData.design_by);
}
